import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	Button,
	DialogContentText,
	DialogActions,
} from "@mui/material";

function ConfirmationDialog(props) {
	return (
		<Dialog
			open={props.open}
			onClose={props.onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">Are you sure?</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					{props.message}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={props.onClose} color="primary">
					No
				</Button>
				<Button onClick={props.onYes} color="primary" autoFocus>
					Yes
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default ConfirmationDialog;